export const TimingLoaded = 'sos.Monitoring.Timing.TimingLoaded';
export interface TimingLoaded {
	type: typeof TimingLoaded;
}
